export default {
  "content": "<path d=\"M1 8h14\" stroke=\"#ff00cb\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};